import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  outlet
} from "react-router-dom";
// import {
//   useQuery,
//   useMutation,
//   useQueryClient,
//   QueryClient,
//   QueryClientProvider,
// } from '@tanstack/react-query'
import { QueryClient, QueryClientProvider } from 'react-query';
import { ChakraProvider } from '@chakra-ui/react'
import DepositProvider from './components/dashboard/Deposit/DepositProvider';
const queryClient = new QueryClient()
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(



  <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <ChakraProvider>
      <Router>
        <App />
      </Router>
    </ChakraProvider>
  
  </QueryClientProvider>
</React.StrictMode>,
);


